import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreateGameTimeSlotMutation,
  useGetGameQuery, 
  useGetLocationQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { ILocation, IGame } from "../../../Api/Interface/api.interface";
import NewPrinter from "../../Printer/Components/NewPopUpPrinter";
import AddIcon from "@mui/icons-material/Add";
import { useStyles } from "../../../theme/appStyles";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import moment from "moment-timezone";

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { data: gamesData } = useGetGameQuery({ searchText: ""});
  const { data: locationsData } = useGetLocationQuery({ searchText: "",});
  const [newLocation, { isLoading }] = useCreateGameTimeSlotMutation();
  const { showErrorMessage, showMessage } = useNotifier();

    const games: IGame[] = Array.isArray(gamesData?.data)
      ? (gamesData?.data as IGame[])
      : [];

    const locations: ILocation[] = Array.isArray(locationsData?.data)
          ? (locationsData?.data as ILocation[])
          : [];


  const formik = useFormik({
   initialValues: {
    game_id: "",
    location_id: "",
    start_time: "",
    end_time: "",
    duration_minutes: "",
    isActive: true,
  },
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await newLocation(values).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
         return formik.values.game_id  === "" &&
           formik.values.game_id  === undefined &&
           formik.values.location_id   === "" &&
           formik.values.location_id   === undefined  &&
           formik.values.start_time   === "" &&
           formik.values.start_time   === undefined &&
           formik.values.end_time   === "" &&
           formik.values.end_time   === undefined &&
           formik.values.duration_minutes   === "" &&
           formik.values.duration_minutes   === undefined 

           ? false
           : true;
       }, [formik]);

  const gridHeight = isMobile ? "30px" : "400px";

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Card className={classes.stepperCard}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Create Game Time Slot
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Game Time Slot Information
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                             Game <span style={{ color: "red" }}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                        select
                        fullWidth
                        size="small"
                        {...formik.getFieldProps("game_id")}
                        className={classes.textField}
                      >
                        <MenuItem value="">Select Game</MenuItem>
                        {games?.map((game: IGame) => (
                          <MenuItem key={game.id} value={game.id}>
                            {game.name}
                          </MenuItem>
                        ))}
                      </TextField>
                        </Grid>
                      </Grid>
                    </Grid>

                   
<Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Location <span style={{ color: "red" }}>*</span></Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
       <TextField
                        select
                        fullWidth
                        size="small"
                        {...formik.getFieldProps("location_id")}
                        className={classes.textField}
                      >
                        <MenuItem value="">Select Location</MenuItem>
                        {locations?.map((location: ILocation) => (
                          <MenuItem key={location.id} value={location.id}>
                            {location.name}
                          </MenuItem>
                        ))}
                      </TextField>
    </Grid>
  </Grid>
</Grid>

<Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Start Time <span style={{ color: "red" }}>*</span></Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
    type="time"
    fullWidth
    size="small"
    InputLabelProps={{ shrink: true }}
    {...formik.getFieldProps("start_time")}
    error={formik.touched.start_time && Boolean(formik.errors.start_time)}
    helperText={formik.touched.start_time && formik.errors.start_time}
  />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">End Time <span style={{ color: "red" }}>*</span></Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
    type="time"
    fullWidth
    size="small"
    InputLabelProps={{ shrink: true }}
    {...formik.getFieldProps("end_time")}
    error={formik.touched.end_time && Boolean(formik.errors.start_time)}
    helperText={formik.touched.end_time && formik.errors.start_time}
  />
    </Grid>
  </Grid>
</Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Active</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <CustomSwitch
                            color="primary"
                            sx={{ mr: 2 }}
                            formik={formik}
                            name="isActive"
                          />
                        </Grid>
                      </Grid>
                    </Grid>





                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={() => formik.resetForm()}
                      >
                        Cancel
                      </Button>
                      <Box m={0.5}></Box>

                      <Button
                        variant="contained"
                        startIcon={<SaveAltIcon />}
                        className={classes.addButton}
                        onClick={() => formik.handleSubmit()}
                        disabled={!formValid || isLoading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
